export class ArrayHelper {
  public static filterDuplicates(array: any[]): any[] {
    return array instanceof Array
      ? array.filter((item: string, index: number, self: string[]) => index === self.indexOf(item))
      : void 0;
  }
}
